
<VirtualList
  class="he-tree"
  :class="{
    'he-tree--rtl rtl': rtl,
    'he-tree--drag-overing drag-overing': dragOvering,
  }"
  role="tree"
  :aria-label="ariaLabel"
  :aria-describedby="ariaInstructionsId"
  @keydown="_onKeydown"
  ref="vtlist"
  :items="visibleStats"
  :disabled="!virtualization"
  :table="table"
  :itemKey="nodeKey"
>
  <template #prepend>
    <slot name="prepend" :tree="self"></slot>
  </template>
  <template #default="{ item: stat, index }">
    <TreeNode
      :vt-index="index"
      :class="[
        stat.class,
        {
          'drag-placeholder-wrapper': stat.data === placeholderData,
          'dragging-node': stat === dragNode,
        },
      ]"
      :style="stat.style"
      :stat="stat"
      :rtl="rtl"
      :btt="btt"
      :indent="indent"
      :table="table"
      :treeLine="treeLine"
      :treeLineOffset="treeLineOffset"
      :processor="processor"
      :activeDescendant="activeDescendant"
      :isPlaceholder="stat.data === placeholderData"
      @click="$emit('click:node', stat)"
      @open="$emit('open:node', $event)"
      @close="$emit('close:node', $event)"
      @check="$emit('check:node', $event)"
    >
      <template #default="{ indentStyle }">
        <template v-if="stat.data === placeholderData">
          <div
            v-if="!table"
            class="drag-placeholder he-tree-drag-placeholder"
          >
            <slot name="placeholder" :tree="self"></slot>
          </div>
          <td v-else :style="indentStyle" :colspan="placeholderColspan">
            <div class="drag-placeholder he-tree-drag-placeholder">
              <slot name="placeholder" :tree="self"></slot>
            </div>
          </td>
        </template>
        <slot
          v-else
          :node="stat.data"
          :stat="stat"
          :indentStyle="indentStyle"
          :tree="self"
          >{{ stat.data[textKey] }}
        </slot>
      </template>
    </TreeNode>
  </template>
  <template #append>
    <slot name="append" :tree="self"></slot>
    <div
      v-if="liveAnnouncement != null"
      class="sr-only"
      aria-live="polite"
      aria-atomic="true"
    >{{ liveAnnouncement }}</div>
    <div
      v-if="i18n?.instructions"
      :id="ariaInstructionsId"
      class="sr-only"
    >{{ i18n.instructions }}</div>
  </template>
</VirtualList>
